onePulse.directive('emitLastRepeater', function() {

    return function(scope) {

        if (scope.$last){

            scope.$emit('LastRepeater');
        }
    };
});